export interface UnprotectedRouteConfig {
  pathname: string
  query?: string
}

export type UnprotectedRoute = UnprotectedRouteConfig | string

export const UNPROTECTED_ROUTES: Array<UnprotectedRoute> = [
  '/login',
  '/logout',
  '/belajar-fe/healthz',
]

export const ROUTE_PATH_NAMES = {
  home: 'Beranda',
}
